export default __webpack_public_path__ + "static/media/elderbird.a91c97b5.png";